var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUnarchivePro = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 23H10C9.449 23 9 22.552 9 22V17H11V20C11 20.553 11.448 21 12 21H20C20.552 21 21 20.553 21 20V17H23V22C23 22.552 22.551 23 22 23ZM12.342 9.553C12.512 9.212 12.855 9 13.236 9H18.764C19.145 9 19.488 9.212 19.658 9.553L22.382 15H20C19.448 15 19 15.447 19 16V19H13V16C13 15.447 12.552 15 12 15H9.618L12.342 9.553ZM24.789 15.342L21.447 8.658C20.936 7.636 19.908 7 18.764 7H13.236C12.092 7 11.064 7.636 10.553 8.658L7.211 15.342C7.073 15.618 7 15.928 7 16.236V22C7 23.654 8.346 25 10 25H22C23.654 25 25 23.654 25 22V16.236C25 15.928 24.927 15.618 24.789 15.342Z",
    fill: "#596C80"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnarchivePro, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unarchive_pro.d2da3534.svg";
export { ForwardRef as ReactComponent };